import { useContext, useState, useMemo, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import ValidateService from '../../services/ValidateService';
import ResVideoListController from '../../controllers/aia/ResVideoListController';
import SelectEnt from '../../components/selectComponents/SelectEnt';
import GbitTablePaging from '../../components/tableComponents/GbitTablePaging';

const ResVideoList = () => {
  useEffect(() => {
    document.title = 'AI영상분석목록';
  }, []);
  const location = useLocation();
  const naviagte = useNavigate();

  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);

  const [searchParam, setSearchParam] = useState({
    entSn: store.entSn,
    pagingYn: 'Y',
    currentPage: 1,
    pageSize: 6,
  });
  const [aplyList, setAplyList] = useState([]);
  const [dataList, setDataList] = useState([]);

  const controller = useMemo(() => {
    return new ResVideoListController(
      { store, updateStore },
      { searchParam, setSearchParam },
      { aplyList, setAplyList },
      { dataList, setDataList },
      modalService,
      validateService,
      naviagte
    );
  }, [store, modalService, validateService]);

  useEffect(() => {
    if (
      searchParam.entSn !== undefined &&
      searchParam.entSn !== null &&
      searchParam.entSn !== ''
    ) {
      setSearchParam({ ...searchParam, aiaAplyId: '' });
      controller.fnSearchAply();
    }
  }, [searchParam.entSn]);

  useEffect(() => {
    if (
      searchParam.entSn !== undefined &&
      searchParam.entSn !== null &&
      searchParam.entSn !== '' &&
      searchParam.aiaAplyId !== undefined &&
      searchParam.aiaAplyId !== null &&
      searchParam.aiaAplyId !== ''
    ) {
      setDataList([]);
      controller.fnSearch();
    }
  }, [searchParam.aiaAplyId]);

  useEffect(() => {
    setSearchParam({
      ...searchParam,
      entSn: location.state?.entSn ?? store.entSn,
      aiaAplyId: location.state?.aiaAplyId,
    });
  }, [location]);

  useEffect(() => {
    return () => {
      controller.disposy();
    };
  }, []);

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">AI영상분석목록</h2>
      </div>
      <ul className="guide-txt">
        <li>
          AI영상분석 목록입니다. 각 AI영상분석에 대한 신청 내역과 분석 결과를
          조회하실 수 있습니다.
        </li>
      </ul>
      <div className="tbl-wrap">
        <p className="tbl-msg">
          <em className="star-require">*</em> 표시는 필수 입력 사항입니다.
        </p>
        <table className="tbl data row">
          <tbody>
            <tr>
              <th scope="row">
                분석신청정보<em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  {store.authrtId === 'ADMIN' && (
                    <SelectEnt
                      model="entSn"
                      valueObj={searchParam}
                      valueChange={(model, value) => {
                        controller.searchParamChange(model, value);
                      }}
                    />
                  )}
                  <label className="hidden-label" htmlFor="sel1" id="sel1Lbl">
                    라벨
                  </label>
                  <select
                    id="sel1"
                    className="form-select md"
                    value={searchParam?.aiaAplyId}
                    onChange={e =>
                      controller.searchParamChange('aiaAplyId', e.target.value)
                    }
                    aria-labelledby="sel1Lbl"
                  >
                    <option value="">선택</option>
                    {aplyList !== undefined &&
                      aplyList !== null &&
                      aplyList.length > 0 &&
                      aplyList.map((apply, index) => {
                        return (
                          <option key={index} value={apply.aiaAplyId}>
                            {apply.aplyNm}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ul className="search-list video-list" style={{ marginTop: '30px' }}>
        {dataList !== undefined &&
          dataList !== null &&
          dataList.length > 0 &&
          dataList.map((data, index) => {
            return (
              <li className="li">
                <div className="card-body">
                  <div className="c-img">
                    <img src={data?.thmbFile} alt="영상 분석 결과 이미지" />
                  </div>
                  <div className="video-status bg1">
                    <div className="video-status-process">
                      <span
                        className={`video-status-item ${
                          data.vldScsYn === 'N'
                            ? 'active success'
                            : data?.vldErrId !== null && data?.vldErrId !== ''
                            ? 'active fail'
                            : ''
                        }`}
                      ></span>
                      <span
                        className={`video-status-item ${
                          data.vldScsYn === 'Y' &&
                          (data.vldErrId === null || data.vldErrId === '') &&
                          (data.aiaScsStts === null || data.aiaScsStts === '')
                            ? 'active success'
                            : ''
                        }`}
                      ></span>
                      <span
                        className={`video-status-item ${
                          ['0', '1', '2', '3', '4'].includes(data.aiaScsStts)
                            ? data.aiaErrId === null || data.aiaErrId === ''
                              ? 'active success'
                              : 'active fail'
                            : ''
                        }`}
                      ></span>
                      <span
                        className={`video-status-item ${
                          data.aiaScsStts === '5' &&
                          (data.aiaErrId === null || data.aiaErrId === '')
                            ? 'active success'
                            : ''
                        }`}
                      ></span>
                    </div>
                    <p>
                      {data.vldScsYn === 'Y'
                        ? data.aiaScsStts === null || data.aiaScsStts === ''
                          ? data.vldErrId === null || data.vldErrId === ''
                            ? '유효성분석완료'
                            : '유효성분석실패'
                          : ['0', '1', '2', '3', '4'].includes(data.aiaScsStts)
                          ? data.aiaErrId === null || data.aiaErrId === ''
                            ? '영상분석중'
                            : '영상분석실패'
                          : data.aiaScsStts === '5'
                          ? data.aiaErrId === null || data.aiaErrId === ''
                            ? '영상분석완료'
                            : '영상분석실패'
                          : ''
                        : '유효성분석중'}
                    </p>
                  </div>
                </div>
                <div className="card-btm">
                  {data.aiaScsStts === '5' &&
                  (data.aiaErrId === null || data.aiaErrId === '') ? (
                    <button
                      type="button"
                      className="btn sm primary"
                      onClick={() => {
                        controller.fnDetail({
                          entSn: searchParam?.entSn,
                          aiaAplyId: data.aiaAplyId,
                          vdoId: data.vdoId,
                          se: data.se,
                        });
                      }}
                    >
                      분석 결과 보기
                    </button>
                  ) : (
                    <button type="button" className="btn sm primary" disabled>
                      분석 결과 보기
                    </button>
                  )}
                </div>
              </li>
            );
          })}
      </ul>
      {dataList !== undefined && dataList !== null && dataList.length > 0 && (
        <GbitTablePaging
          totalItems={parseInt(dataList?.[0]?.totalCount)}
          itemsPerPage={searchParam?.pageSize}
          currentPage={searchParam?.currentPage}
          onPageChange={value => {
            controller.fnSearch(value);
          }}
        />
      )}
    </>
  );
};

export default ResVideoList;
